<template>
  <div id="exportPDF" class="pb-10" style="height: 90vh">
    <v-container>
      <div class="header text-center my-10" >
        <h1>โครงการพัฒนาน้ำบาดาลเพื่อการอุปโภคบริโภคขนาดใหญ่</h1>
        <h3>บ้านพัฒนา ตำบลกุดเรือดำ อำเภอวานรนิวาศ จังหวัดสกลนคร</h3>
      </div>
      <div v-if="isExportDataType(deviceId) == 'singleLevel'" 
        class="mx-0 mx-xl-16 px-0 px-xl-16"
      >
        <ejs-grid 
          ref='grid' 
          id='Grid' 
          :dataSource='postData' 
          :toolbar='toolbarOptions' 
          height='auto' 
          :allowPdfExport='true' 
          :allowExcelExport='true'
          :allowSorting='true' 
          :allowFiltering='true'
          :filterSettings='filterOptions'
          :toolbarClick='gridExport'
        >
          <e-columns>
            <e-column field='deviceId' :filter='filter' headerText='Device ID' textAlign='Start' width=120></e-column>
            <e-column field='date' :filter='filter' headerText='Date' textAlign='Center' width=80></e-column>
            <e-column field='level' headerText='Total (m³)' textAlign='Center'  width=120></e-column>
            <e-column field='level_percent' headerText='Total (%)' textAlign='Center'  width=120></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div v-if="isExportDataType(deviceId) == 'singleTds'" 
        class="mx-0 mx-xl-16 px-0 px-xl-16"
      >
        <ejs-grid 
          ref='grid' 
          id='Grid' 
          :dataSource='postData' 
          :toolbar='toolbarOptions' 
          height='auto' 
          :allowPdfExport='true' 
          :allowExcelExport='true'
          :allowSorting='true' 
          :allowFiltering='true'
          :filterSettings='filterOptions'
          :toolbarClick='gridExport'
        >
          <e-columns>
            <e-column field='deviceId' :filter='filter' headerText='Device ID' textAlign='Start' width=120></e-column>
            <e-column field='date' :filter='filter' headerText='Date' textAlign='Center' width=80></e-column>
            <e-column field='max_tds' headerText='Max TDS (PPM) / Max EC(μS/cm)' textAlign='Center' width=120></e-column>
            <e-column field='min_tds' headerText='Min TDS (PPM) / Max EC(μS/cm)'  textAlign='Center' width=120></e-column>
            <e-column field='avg_tds' headerText='Avg. TDS (PPM) / Max EC(μS/cm)'  textAlign='Center' width=120></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div v-if="isExportDataType(deviceId) == 'duoFlow'" 
        class="mx-0 mx-xl-16 px-0 px-xl-16"
      >
        <ejs-grid 
          ref='grid' 
          id='Grid' 
          :dataSource='postData' 
          :toolbar='toolbarOptions' 
          height='auto' 
          :allowPdfExport='true' 
          :allowExcelExport='true'
          :allowSorting='true' 
          :allowFiltering='true'
          :filterSettings='filterOptions'
          :toolbarClick='gridExport'
        >
          <e-columns>
            <e-column field='deviceId' :filter='filter' headerText='Device ID' textAlign='Start' width=120></e-column>
            <e-column field='date' :filter='filter' headerText='Date' textAlign='Center' width=80></e-column>
            <e-column field='max_flow' headerText='Max Flow (m³/hr)' textAlign='Center' width=120></e-column>
            <e-column field='min_flow' headerText='Min Flow (m³/hr)'  textAlign='Center' width=120></e-column>
            <e-column field='avg_flow' headerText='Avg. Flow (m³/hr)'  textAlign='Center' width=120></e-column>
            <e-column field='total_flow' headerText='Total Flow (m³/hr)' textAlign='Center'  width=120></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div v-if="isExportDataType(deviceId) == 'duoTds'" 
        class="mx-0 mx-xl-16 px-0 px-xl-16"
      >
        <ejs-grid 
          ref='grid' 
          id='Grid' 
          :dataSource='postData' 
          :toolbar='toolbarOptions' 
          height='auto' 
          :allowPdfExport='true' 
          :allowExcelExport='true'
          :allowSorting='true' 
          :allowFiltering='true'
          :filterSettings='filterOptions'
          :toolbarClick='gridExport'
        >
          <e-columns>
            <e-column field='deviceId' :filter='filter' headerText='Device ID' textAlign='Start' width=120></e-column>
            <e-column field='date' :filter='filter' headerText='Date' textAlign='Center' width=80></e-column>
            <e-column field='max_tds' headerText='Max TDS (PPM) / Max EC(μS/cm)' textAlign='Center' width=120></e-column>
            <e-column field='min_tds' headerText='Min TDS (PPM) / Max EC(μS/cm)'  textAlign='Center' width=120></e-column>
            <e-column field='avg_tds' headerText='Avg. TDS (PPM) / Max EC(μS/cm)'  textAlign='Center' width=120></e-column>
            <e-column field='max_level' headerText='Max Level (M)' textAlign='Center'  width=120></e-column>
            <e-column field='min_level' headerText='Min Level (M)' textAlign='Center'  width=120></e-column>
            <e-column field='avg_level' headerText='Avg. Level (M)' textAlign='Center'  width=120></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div v-if="isExportDataType(deviceId) == 'triple'" 
        class="mx-0 mx-xl-16 px-0 px-xl-16"
      >
        <ejs-grid 
          ref='grid' 
          id='Grid' 
          :dataSource='postData' 
          :toolbar='toolbarOptions' 
          height='auto' 
          :allowPdfExport='true' 
          :allowExcelExport='true'
          :allowSorting='true' 
          :allowFiltering='true'
          :filterSettings='filterOptions'
          :toolbarClick='gridExport'
        >
          <e-columns>
            <e-column field='deviceId' :filter='filter' headerText='Device ID' textAlign='Start' width=120></e-column>
            <e-column field='date' :filter='filter' headerText='Date' textAlign='Center' width=80></e-column>
            <e-column field='max_flow' headerText='Max Flow (m³/hr)' textAlign='Center' width=120></e-column>
            <e-column field='min_flow' headerText='Min Flow (m³/hr)'  textAlign='Center' width=120></e-column>
            <e-column field='avg_flow' headerText='Avg. Flow (m³/hr)'  textAlign='Center' width=120></e-column>
            <e-column field='total_flow' headerText='Total Flow (m³/hr)' textAlign='Center'  width=120></e-column>
            <e-column field='max_prs' headerText='Max PRS (PPM) / Max EC(μS/cm)' textAlign='Center' width=120></e-column>
            <e-column field='min_prs' headerText='Min PRS (PPM) / Max EC(μS/cm)'  textAlign='Center' width=120></e-column>
            <e-column field='avg_prs' headerText='Avg. PRS( PPM) / Max EC(μS/cm))'  textAlign='Center' width=120></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import services from '@/services/services'
import { GridPlugin,Page, Toolbar, PdfExport, ExcelExport , Sort, Filter } from "@syncfusion/ej2-vue-grids";
import { PdfTrueTypeFont } from '@syncfusion/ej2-pdf-export';
import { robotoBase64 } from '@/assets/fonts/base64/robotoBase64'
import { base64font } from '@/assets/fonts/base64/base64font'
import { image } from '@/assets/images/logo/base64/logoRBF'
import moment from 'moment'
Vue.use(GridPlugin);

export default {
    name: 'exportPDF',
    data: () => ({
      currentDate: moment().format("YYYY_MM_DD"),
      data: {},
      pageSettings: {pageSize: 6},
      toolbarOptions: ['PdfExport', 'ExcelExport'],
      filterOptions: {
        type: 'Menu'
      },
      filter: {
        type : 'CheckBox'
      },
      postData: [],
      deviceId: '',
      singleMeterLevelId: ['4708130200201', '4708130200701'],
      singleMeterTdsId: ['4708130201001', '4708130201002']
    }),
    provide: {
      grid: [Page, Toolbar, PdfExport, ExcelExport, Sort, Filter ]
    },
    props: {
      topic: {
        type: String
      },
      meterValue: {
        type: Array,
        default: () => []
      },
      valueType: {
        type: String,
        default: ''
      },
    },
    methods: {
      isExportDataType(deviceId){
        if (this.singleMeterLevelId.includes(deviceId)){
          return 'singleLevel'
        } 
        else if (this.singleMeterTdsId.includes(deviceId)) {
          return 'singleTds'
        } 
        else if (this.duoMeterTdsId.includes(deviceId)) {
          return 'duoTds'
        } 
        else if (this.duoMeterFlowId.includes(deviceId)) {
          return 'duoFlow'
        } 
        else {
          return 'triple'
        }
      },
      gridExport(args){
        var girdInst = this.$refs.grid;
        if(girdInst){
          if(args.item.id.includes('pdfexport')){
            girdInst.pdfExport({
              fileName: "dgr_scage_sakhonnakhon_"+this.currentDate+".pdf",
              exportType: "CurrentPage",
              pageSize: 'A4',
              theme: {
                header: {
                  bold: true,
                  // fontName: "Calibri",
                  // fontSize: 8,
                  font:  new PdfTrueTypeFont(robotoBase64.font, 8) 
                  
                },
                record: {
                  fontColor: "#000000",
                  fontName: "Calibri",
                  fontSize: 8,
                }
              },
              header:{
                fromTop: 0,
                height: 150,
                contents: [
                    {
                      type: "Text",
                      font:  new PdfTrueTypeFont(base64font.font, 22),
                      bold: true,
                      value: "โครงการพัฒนาน้ำบาดาลเพื่อการอุปโภคบริโภคขนาดใหญ่",
                      position: { x: 0, y: 20 },
                      style: { fontSize: 20, hAlign: 'Center',  textBrushColor: '#000000'}
                    },
                    {
                      type: "Text",
                      font:  new PdfTrueTypeFont(base64font.font, 18) ,
                      value: "บ้านพัฒนา ตำบลกุดเรือดำ อำเภอวานรนิวาศ จังหวัดสกลนคร",
                      position: { x: 0, y: 55 },
                      style: { fontSize: 12, hAlign: 'Center',  textBrushColor: '#000000', bold: true}
                    },
                    {
                      type: 'Image',
                      src: image.logo,
                      position: { x: 550, y: 0 },
                      size: { height: 100, width: 80 },
                    }
                ]
              },
              footer: {
                contents: [ 
                  {
                    type: 'PageNumber',
                    pageNumberType: 'Number',
                    format: 'Page {$current} of {$total}', //optional
                    position: { x: 600, y: 110 },
                    style: { textBrushColor: '#000000', fontSize: 12, hAlign: 'Center' }
                  }
                ],
                fromBottom: 130,
                height: 130
              }
            }); 
          } else if(args.item.id.includes('excelexport')){
            girdInst.excelExport({
              fileName: "dgr_scage_sakhonnakhon_"+this.currentDate+".xlsx",
              exportType: "CurrentPage",
              theme: {
                header: {
                  bold: true,
                  fontName: "Calibri",
                  fontSize: 12
                },
                record: {
                  fontColor: "#000000",
                  fontName: "Calibri",
                  fontSize: 12
                }
              },
            })
          }
        }
      }
    },
    async mounted() {
      this.deviceId = this.$route.query.deviceId
      this.postData = await services.getExportDataByDeviceId(this.$route.query)
      this.postData = this.postData.data
      // console.log("postData", this.postData);
    } 
}
</script>

<style scope>
@import url("https://cdn.syncfusion.com/ej2/material.css");

#exportPDF {
  font-family: "Kanit";
  background-color: white;
  overflow: auto;
}

</style>